import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import OrderDetails from '../components/order-detail/order-detail'
import dataLoad from '../actions/data-load';

function mapStateToProps(state) {
    // console.log("state are order >>>>>", state)
  return {
    orderDetails: state.orderDetails,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);